import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import AlertMessage from '@components/Utilities/AlertMessage';
import Sidebar from '@components/Utilities/Sidebar';
import Navbar from '@components/Utilities/Navbar';
import Loader from '@components/Utilities/Loader';
import ActivityDrawer from '@components/Utilities/ActivityDrawer';
import UpdateBanner from '@components/Utilities/UpdateBanner';
import { PREVIEW_BANNER_HEIGHT, useProfilePreview } from '@hooks/useProfilePreview';
import { useAppUpdateChecker } from '@hooks/useAppUpdateChecker';

const System: React.FunctionComponent = () => {
    const { isLoading } = useSelector((state: RootReducer) => state.app);
    const [open, setOpen] = useState(false);
    // La barra de "Ver como" ocupa alto real: sin descontarla, toda pantalla
    // que use height 100% se pasa de la ventana y aparece scroll de página
    const { isPreviewing } = useProfilePreview();
    const chromeHeight = 70 + (isPreviewing ? PREVIEW_BANNER_HEIGHT : 0);
    // Auto-actualización: recarga sola donde es seguro (tablero de cocina, al
    // navegar) y banner con botón donde no (POS con carrito en memoria)
    const { updateAvailable, reloadNow } = useAppUpdateChecker();

    const handleDrawerToggle = () => {
        setOpen(!open);
    };

    return (
        <Box height="100vh">
            <CssBaseline />
            <Navbar handleDrawerToggle={handleDrawerToggle} />
            <Sidebar handleDrawerToggle={handleDrawerToggle} open={open} />
            <Box height={`calc(100% - ${chromeHeight}px)`}>
                <Outlet />
            </Box>
            {isLoading && <Loader />}
            <AlertMessage />
            <ActivityDrawer />
            {updateAvailable && <UpdateBanner onReload={reloadNow} />}
        </Box>
    );
};

export default System;
